import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Register PWA Service Worker (production only, never inside Lovable preview iframe)
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  const inIframe = (() => {
    try {
      return window.self !== window.top;
    } catch {
      return true;
    }
  })();
  const isPreviewHost =
    location.hostname.includes("id-preview--") ||
    location.hostname.includes("lovableproject.com");

  if (!inIframe && !isPreviewHost) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/sw.js")
        .catch((err) => console.warn("[SW] registration failed", err));
    });
  }
}
